import getWithToken from './base/get-with-token'

const getCustomersDetail = id => getWithToken(`/customer/${id}`)()

export default getCustomersDetail